<template>
    <el-dialog :title="formDialog.title" :visible.sync="formDialog.visible" direction="rtl" :before-close="closeDialog" width="30%">
        <div class="dialog-form">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" label-position="left">
                <el-form-item label="渠道类型" prop="type">
                    <el-select v-model="ruleForm.type" placeholder="请选择">
                        <el-option label="红丝平台" value="1"></el-option>
                        <el-option label="门店" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="区域" prop="online">
                    <el-select v-model="ruleForm.city_id" clearable placeholder="请选择">
                        <el-option v-for="(item, index) in region" :key="index" :label="item.title" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="线上/线下" prop="online">
                    <el-select v-model="ruleForm.online" clearable placeholder="请选择">
                        <el-option label="线上" value="1"></el-option>
                        <el-option label="线下" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="渠道名称" prop="title">
                    <el-input v-model="ruleForm.title"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input v-model="ruleForm.sort"></el-input>
                </el-form-item>
                  <el-form-item label="上/下架" prop="is_valid">
                    <el-select v-model="ruleForm.is_valid" clearable placeholder="请选择">
                        <el-option label="上架" value="1"></el-option>
                        <el-option label="下架" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="saveDialog('ruleForm')">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>
import dictionary from '@/utils/dictionary.js';
let formFields =  {
    id: 0,
    type: '',
    online: '',
    city_id: '',
    title: '',
    is_valid: '',
    sort: 0
};

export default {
    props: {
        parent: {}
    },
    data() {
        let region = dictionary.getRegion();

        return {
            formDialog: {
                title: '',
                visible: false,
                method: 'create'
            },
            region: region,
            ruleForm:  Object.assign({}, formFields),
            rules: {
                type: [{ required: true, message: '请选择渠道类型', trigger: 'blur' }],
                city_id: [{ required: true, message: '请选择区域', trigger: 'blur' }],
                online: [{ required: true, message: '请选择线上、线下', trigger: 'blur' }],
                title: [{ required: true, message: '请输入渠道名称', trigger: 'blur' }]
            }
        };
    },
    methods: {
        // 显示添加、编辑渠道视图
        showDialog(row) {
            let that = this;
            this.ruleForm = Object.assign({}, formFields);
            this.formDialog.visible = true;
            // 添加渠道
            if (!row) {
                this.formDialog.title = '添加来源';
                this.formDialog.action = '/api/dictionary.source/create';
                return false;
            }

            // 编辑渠道
            this.formDialog.title = '编辑来源';
            this.formDialog.action = '/api/dictionary.source/save';
            let url = '/api/dictionary.source/read';
            let query = { id: row.id };
            that.$post(url, query).then(function(res) {
                if (res.code != '200') {
                    that.$message.error(res.msg);
                    return false;
                }

                // 同步数据
                let row = res.data.row;
                row.type = row.type + '';
                row.online = row.online + '';
                row.is_valid = row.is_valid + '';
                row.city_id = row.city_id == 0 ? '' : row.city_id + '';
                that.ruleForm = row;
            });
        },

        // 保存
        saveDialog(formName) {
            let that = this;
            let query = this.ruleForm;
            let dialog = this.formDialog;
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$post(dialog.action, query).then(function(response) {
                        if (response.code == '200') {
                            that.parent.getTableData();
                            that.closeDialog();
                            that.$message.success(response.msg);
                        } else {
                            that.$message.error(response.msg);
                        }
                    });
                } else {
                    this.$message('请填写完整并检查您的填写信息');
                }
            });
        },
        // 清空内容
        closeDialog() {
            this.formDialog.visible = false;
            this.treeChecked = [];
            this.$refs['ruleForm'].resetFields();
        }
    }
};
</script>

<style lang="less">
.dialog-form {
  padding: 20px;
}
.user-edit .el-dialog__body {
    overflow: auto;
}
/* input Number类型不要上下箭头 */

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
}
</style>
